<template>
  <div class="map-header">
    <!-- Título e Seletor de Cliente -->
    <div class="header-content">
      <div class="row items-center justify-between">
        <div class="col-auto">
          <div class="page-title">
            <span class="text-h5 text-weight-medium breadcrumb-title">
              Dashboard > {{ getClienteName() }}
            </span>
          </div>
        </div>
        <div class="col-auto">
          <!-- Botões de Seleção de Cliente -->
          <div class="client-buttons-group">
            <!-- Botão Visão Geral -->
            <q-btn
              :class="['client-btn', 'visao-geral', { 'active': !clienteSelecionado }]"
              flat
              @click="onClienteChange(null)"
              :loading="loading"
            >
              <div class="client-btn-content">
                <q-icon name="public" size="sm" class="btn-icon" />
                <span class="client-name">{{ this.$gettext('INDUSTRIAL_MAP_GENERAL_VIEW') }}</span>
              </div>
            </q-btn>

            <!-- Botões dos Clientes -->
            <q-btn
              v-for="cliente in clientes"
              :key="cliente.id"
              :class="['client-btn', 'cliente-btn', { 'active': clienteSelecionado === cliente.id }]"
              flat
              @click="onClienteChange(cliente.id)"
              :loading="loading"
            >
              <div class="client-btn-content">
                <span class="client-name">{{ cliente.nomeFantasia || cliente.name }}</span>
              </div>
            </q-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'MapHeader'
})
class MapHeader extends Vue {
  @Prop({ type: Array, default: () => [] })
  clientes

  @Prop({ type: Object, default: null })
  clienteSelecionado

  @Prop({ type: Boolean, default: false })
  loading

  @Prop({ type: String, default: '' })
  clienteNome

  @Prop({ type: String, default: '' })
  clienteInfo1

  @Prop({ type: String, default: '' })
  clienteInfo2

  onClienteChange (cliente) {
    this.$emit('cliente-change', cliente)
  }

  getClienteName () {
    if (!this.clienteSelecionado) {
      return 'Visão Geral'
    }
    return this.clienteNome || 'Cliente'
  }
}

export default MapHeader
</script>

<style lang="stylus" scoped>
@import '~quasar-variables'

.map-header
  background: white

  .header-content
    padding: 16px 24px

    .page-title
      display: flex
      align-items: center

      .breadcrumb-title
        color: #707070
        margin: 0
        font-family: Roboto
        font-size: 20px
        font-style: normal
        font-weight: 500
        line-height: normal
        display: flex
        align-items: center

        // Sublinhado no Dashboard
        &::after
          content: ''
          position: absolute
          bottom: -2px
          left: 0
          width: 6rem // Largura aproximada da palavra "Dashboard"
          height: 2px
          background-color: #D18E4B

        // Posicionamento relativo para o sublinhado
        position: relative

    .client-buttons-group
      display: flex
      gap: 0
      align-items: center

      .client-btn
        display: flex
        height: 36px
        min-width: 160px
        padding: 6px 16px
        justify-content: center
        align-items: center
        gap: 10px
        border-radius: 0
        border: 1px solid #E0E0E0
        border-right: none

        // Primeiro botão (Visão Geral) com canto esquerdo arredondado
        &.visao-geral
          border-radius: 4px 0 0 4px

        // Último botão com canto direito arredondado
        &:last-child
          border-radius: 0 4px 4px 0
          border-right: 1px solid #E0E0E0
        background: white
        color: #707070
        transition: all 0.3s ease

        // Garantir alinhamento consistente para todos os botões
        .q-btn__content
          display: flex !important
          align-items: center !important
          justify-content: center !important
          height: 100% !important
          width: 100% !important
          padding: 0 !important

        // Override específico para Visão Geral com ícone
        &.visao-geral
          .q-btn__content
            position: relative !important

          .client-btn-content
            position: absolute !important
            top: 50% !important
            left: 50% !important
            transform: translate(-50%, -50%) !important
            display: flex !important
            align-items: center !important
            justify-content: center !important
            width: auto !important
            height: auto !important
            padding: 0 !important

        &:hover
          border-color: #0E88E4
          background: rgba(14, 136, 228, 0.05)

        // Estilo para botões ativos (tanto Visão Geral quanto Clientes)
        &.active
          background: #0E88E4
          border-color: #0E88E4
          color: white

          .q-icon
            color: white

        .client-btn-content
          display: flex
          flex-direction: row
          align-items: center
          justify-content: center
          gap: 10px
          height: 100%
          width: 100%
          padding: 0
          box-sizing: border-box

          .btn-icon
            flex-shrink: 0
            display: flex
            align-items: center
            margin: 0
            line-height: 1

          .client-name
            font-family: Roboto, sans-serif
            font-weight: 500
            font-size: 16px
            line-height: 1 // 100%
            letter-spacing: 0 // 0%
            text-align: center
            text-transform: uppercase
            white-space: nowrap
            display: flex
            align-items: center

  @media (max-width: 599px)
    .header-content
      padding: 12px 16px

      .row
        flex-direction: column
        gap: 12px

      .client-buttons-group
        flex-wrap: wrap
        justify-content: center

        .client-btn
          min-width: 140px
          height: 32px
          padding: 4px 12px

          .client-btn-content
            gap: 8px
            padding: 0

            .client-name
              font-size: 12px
</style>
